import { render, staticRenderFns } from "./GrupoEtqAmostras.vue?vue&type=template&id=6ec084de&"
import script from "./GrupoEtqAmostras.vue?vue&type=script&lang=js&"
export * from "./GrupoEtqAmostras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports